/**
 * @generated SignedSource<<27da0f6f1232058299c33ecc5390e36b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateErrorInput = {
  id: string;
  fixed?: boolean | null;
  excludeFromStats?: boolean | null;
  notes?: string | null;
  team?: string | null;
  knownType?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateErrorMutation$variables = {
  input: UpdateErrorInput;
};
export type updateErrorMutation$data = {
  readonly UpdateError: {
    readonly MissionControlErrorList: {
      readonly id: string;
      readonly actualId: number | null;
      readonly timestamp: string | null;
      readonly personId: number | null;
      readonly personName: string | null;
      readonly companyId: number | null;
      readonly companyName: string | null;
      readonly correlationId: string | null;
      readonly fixed: boolean | null;
      readonly notes: string | null;
      readonly excludeFromStats: boolean | null;
      readonly lastUpdatedByName: string | null;
      readonly bugDuty: string | null;
      readonly team: string | null;
      readonly url: string | null;
      readonly knownType: string | null;
    } | null;
  } | null;
};
export type updateErrorMutation = {
  variables: updateErrorMutation$variables;
  response: updateErrorMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateErrorPayload",
    "kind": "LinkedField",
    "name": "UpdateError",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlErrorListType",
        "kind": "LinkedField",
        "name": "MissionControlErrorList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "correlationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fixed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excludeFromStats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUpdatedByName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bugDuty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "team",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "knownType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateErrorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateErrorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "72be4094a0025fc6e6a38f3bfacb1ad1",
    "id": null,
    "metadata": {},
    "name": "updateErrorMutation",
    "operationKind": "mutation",
    "text": "mutation updateErrorMutation(\n  $input: UpdateErrorInput!\n) {\n  UpdateError(input: $input) {\n    MissionControlErrorList {\n      id\n      actualId\n      timestamp\n      personId\n      personName\n      companyId\n      companyName\n      correlationId\n      fixed\n      notes\n      excludeFromStats\n      lastUpdatedByName\n      bugDuty\n      team\n      url\n      knownType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0939106fe3bf662139a14b9784b3646";

export default node;
